import { ALL, PLATFORM_OPTIONS } from '../constants';
import { get } from 'lodash';
import { isFeatureEnabled } from 'h-commons';

/**
 * @param {Array} integrationMarketplace Full list of integration app data
 * @param {String} selected selected categorie
 * @param {Boolean} showInstalled show installed check box
 */
const filterApps = ({
  integrationMarketplace,
  selected,
  showInstalled,
}) => {
  const list = get(integrationMarketplace, 'app_list', []);
  let filteredList = list;
  if (showInstalled) {
    filteredList = list.filter((app) => app.enabled);
  }
  if (selected == ALL) {
    return filteredList;
  }
  filteredList = filteredList.filter((app) => app.category == selected);
  return filteredList;
};

const getTabData = (appData, selectedTab) =>
  appData && Array.isArray(appData.details)
    ? appData.details.find((tab) => tab.type === selectedTab)
    : {};

const getAppEnablePayload = ({ selected, app_list }, { payload }) => {
  const isEnabled = payload.enabled === 1;
  const selectedAppIndex = selected.details.findIndex(
    (detail) => detail.type === payload.type
  );
  selected.details[selectedAppIndex].enabled = isEnabled;
  const appIndex = app_list.findIndex((app) => app.id === payload.id);
  app_list[appIndex]['enabled'] = isEnabled;
  selected.enabled = selected.details.reduce((acc, type) => type.enabled || acc, isEnabled);
  return { app_list, selected };
};

const filterScreenshot = (screenshotList) =>
  screenshotList.filter((screenshot) => !screenshot.includes('x.png'));

const filterHigherResolution = (screenshotList) =>
  screenshotList.filter((screenshot) => screenshot.includes('x.png'));

const getUserDetails = (platform) => {
  try {
    let userDetails = JSON.parse(localStorage.getItem(`${platform}_userDetails`));
    return getUserDetailsByPlatform(platform, userDetails);
  } catch (ex) {
    return {
      name: null,
      email: null,
      avatarUrl: null,
    };
  }
}

const getUserDetailsByPlatform = (platform, userDetails) => {
  try {
    switch (platform) {
      case PLATFORM_OPTIONS.SALESFORCE:
        return {
          name: `${userDetails["first name"]} ${userDetails["last name"]}`,
          email: userDetails.email,
          avatarUrl: userDetails.avatarUrl.thumbnail,
        };
      default:
        throw new Error(`${platform} is not a valid platform`)
    }
  } catch (ex) {
    return {
      name: null,
      email: null,
      avatarUrl: null,
    };
  }
}

export {
  filterApps,
  getTabData,
  getAppEnablePayload,
  filterScreenshot,
  filterHigherResolution,
  getUserDetails,
  getUserDetailsByPlatform,
};
